import c from "classnames";
import styles from "./logo.module.css";

import { Link } from "react-router-dom";
import routes from "@/routes";

// Логотип приложения
// Содержит картинку и название
// При сворачивании может скрывать название
const Logo = ({
  collapsed,
  version,
  logo,
  logo_text,
  isRed = false,
  className,
}) => {
  return (
    <div
      to={routes.dashboards}
      className={c(styles.wrap, collapsed && styles.collapsed, className)}
    >
      <Link to={routes.dashboards} className={styles.link}>
        {logo && <img src={logo} width={32} height={32} alt="Логотип" />}
        <span className={!isRed ? styles.name : styles.name_placeholder}>
          {logo_text}
        </span>
      </Link>
      {version && (
        <div className={styles.version}>
          v{version?.version}
          <br></br>
          {version?.date}
        </div>
      )}
    </div>
  );
};

export default Logo;
